const action_types = require('./action-types');

let actions = {
  switchLanguage(language) {
    return {
      type: action_types.SWITCH_LANGUAGE,
      language
    }
  },
  toggleMenu() {
    return {
      type: action_types.TOGGLE_MENU
    }
  }
};

module.exports = actions;



// WEBPACK FOOTER //
// ./src/actions.js